<template>
    <PopoverRoot
        :open="popoverOpen"
        @update:open="
            (value) => {
                popoverOpen = value;
            }
        "
    >
        <PopoverTrigger as-child>
            <button class="input w-full flex items-center justify-between">
                {{ model }}
                <AtomIcon name="calendar" />
            </button>
        </PopoverTrigger>
        <PopoverPortal>
            <PopoverContent
                side="bottom"
                :side-offset="5"
                class="rounded p-1 bg-white shadow-md will-change-[transform,opacity] data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade"
            >
                <div class="calendar">
                    <ClientOnly>
                        <VDatePicker
                            v-model.string="model"
                            is-required
                            :locale="locale"
                            :min-date="$dayjs().format('YYYY-MM-DD')"
                            :max-date="
                                $dayjs().add(2, 'year').format('YYYY-MM-DD')
                            "
                            :attributes="attrs"
                            :masks="{ modelValue: 'YYYY-MM-DD' }"
                        >
                        </VDatePicker>
                    </ClientOnly>
                </div>

                <PopoverArrow class="fill-white" />
            </PopoverContent>
        </PopoverPortal>
    </PopoverRoot>
</template>

<script setup>
import {
    PopoverArrow,
    PopoverContent,
    PopoverPortal,
    PopoverRoot,
    PopoverTrigger,
} from "radix-vue";

const locale = useEnv("locale");

const model = defineModel();
const popoverOpen = ref(false);

const attrs = ref([
    {
        key: "today",
        dot: true,
        dates: new Date(),
    },
]);

watch(model, () => {
    if (popoverOpen.value) {
        popoverOpen.value = false;
    }
});
</script>

<style lang="scss" scoped>
.calendar {
    &:deep(.vc-container) {
        @apply bg-transparent;
    }

    &:deep(.vc-bordered) {
        @apply border-0 w-full;
    }

    &:deep(.vc-header) {
        @apply text-base p-0 m-0;
    }

    &:deep(.vc-header .vc-arrow) {
        @apply text-coral;
    }

    &:deep(.vc-header .vc-arrow:hover) {
        @apply bg-transparent;
    }

    &:deep(.vc-weekday) {
        @apply text-black opacity-60 text-xs font-medium;
    }

    &:deep(.vc-weeks) {
        @apply p-0;
    }

    &:deep(.vc-dot) {
        @apply bg-coral;
    }

    &:deep(.vc-day-content) {
        @apply transition-all;
    }

    &:deep(.vc-day-content:hover:not(.vc-highlight-content-solid)) {
        @apply bg-mist;
    }

    &:deep(.vc-highlight-bg-solid),
    &:deep(.vc-day-content:hover) {
        @apply bg-coral;
    }

    &:deep(.vc-focus) {
        @apply shadow-none;
    }

    &:deep(.vc-nav-item.is-active) {
        @apply bg-coral;
    }
}
</style>
